import React, { memo, useState, useRef, useEffect } from 'react'
import { agnostify, canUseDom } from '@sainsburys-tech/boltui-utils'
import { trackEvent, isBlackFriday } from '../ComponentHelper'
import { StyledContainer, StyledCopy, StyledSeoSeeMoreLess } from './Seo.styles'
import { SeoProps } from './types'

const Seo = ({ bodyCopy = '', collapsible = true }: SeoProps): React.ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [seoHeight, setSeoHeight] = useState({})
  const targetRef = useRef(null)

  const toggleSeo = () => {
    if (canUseDom() && isBlackFriday(window) && isCollapsed) {
      trackEvent(
        {
          eventInfo: {
            eventName: 'bf_wibf_seeMore',
            eventAction: 'What Is Black Friday See More'
          }
        },
        window
      )
    }
    setIsCollapsed(!isCollapsed)
  }

  useEffect(() => {
    setSeoHeight(targetRef.current.getBoundingClientRect().height)
  }, [])

  const isValidCollapsible = collapsible && seoHeight > 150
  return (
    <StyledContainer data-test='seo'>
      <StyledCopy
        isCollapsed={isCollapsed}
        isValidCollapsible={isValidCollapsible}
        data-test={`seo-copy-collapsed-${isCollapsed}`}
      >
        <div data-test='seo-copy' ref={targetRef} dangerouslySetInnerHTML={{ __html: agnostify(bodyCopy) }} />
      </StyledCopy>
      {isValidCollapsible && (
        <button type='button' onClick={() => toggleSeo()}>
          <StyledSeoSeeMoreLess data-test='seo-see-more-less'>
            <strong>{isCollapsed ? 'Read more' : 'Show less'}</strong>
            <span />
          </StyledSeoSeeMoreLess>
        </button>
      )}
    </StyledContainer>
  )
}

export default memo(Seo)
